import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.333 8.333H6.667a.667.667 0 0 0 0 1.334h2.666a.667.667 0 0 0 0-1.334m3.334-4.666H8.48L8.267 3a2 2 0 0 0-1.894-1.333h-3.04a2 2 0 0 0-2 2v8.666a2 2 0 0 0 2 2h9.334a2 2 0 0 0 2-2V5.667a2 2 0 0 0-2-2m.666 8.666a.667.667 0 0 1-.666.667H3.333a.666.666 0 0 1-.666-.667V3.667A.667.667 0 0 1 3.333 3h3.04a.67.67 0 0 1 .634.453l.36 1.094A.67.67 0 0 0 8 5h4.667a.667.667 0 0 1 .666.667z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })